import { LoadingSpinner } from '@CommonComponents'
import React, { useState } from 'react'
import { history } from '../App'

export const ItemsSelected = props => {
  const contextId = window.location.pathname.split('/')[4]
  let [useNewTab, setUseNewTab] = useState(true)

  const resetFinish = () => {
    props.resetFunc(...props.resetParams)
    history.push(
      `/links/canvas_connect.instructor_setup/-/${contextId}${window.location.search}`
    )
  }
  return (
    <div
      className="bg-white px-5 pb-4 pt-1 rounded"
      style={{ marginTop: '1.25rem' }}
    >
      {!props.posted ? (
        <React.Fragment>
          {!props.posting ? (
            <React.Fragment>
              <h1 className="text-center">{props.items.length}</h1>
              <h4 className="text-center mb-3">
                {`${props.contentType}(s) selected`}
              </h4>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="d-flex justify-content-center mt-4">
                <LoadingSpinner style={{ fontSize: '25px' }} />
              </div>
              <h4 className="text-center mb-3">
                {`${props.currentItem} of ${props.items.length}`}
              </h4>
            </React.Fragment>
          )}
          <div className="d-flex align-items-center">
            <input
              label=""
              type="checkbox"
              className="mr-1"
              checked={useNewTab}
              onChange={() => {
                setUseNewTab(!useNewTab)
              }}
            />
            <span className="ml-1">Set links to open in new tab</span>
          </div>
          {!useNewTab && (
            <div className="text-center my-4">
              <span className="text-warning">
                <i>
                  Choosing not to open assessment links in new tabs may cause
                  problems with certain browsers.
                </i>
              </span>
            </div>
          )}
          <button
            className="btn btn-success btn-myed btn-success-myed my-3 btn-block"
            disabled={props.items.length == 0 || props.posting}
            onClick={() => props.postItems(...props.postParams, useNewTab)}
          >
            {`Create ${props.contentCategory} Links in Canvas`}
          </button>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <h4 className="text-success">
            {`Successfully configured ${
              props.items.length
            } ${props.contentCategory.toLowerCase()} ${
              props.items.length == 1 ? 'link' : 'links'
            } in Canvas.`}
          </h4>
          <a
            className="btn btn-success btn-myed btn-success-myed mt-5 btn-block"
            onClick={() => resetFinish()}
          >
            Finish
          </a>
          <div className="text-center mt-5">
            <a
              className="text-dec-none"
              onClick={() => props.resetFunc(...props.resetParams)}
            >
              <div className="fa-regular fa-redo" /> Repeat this step
            </a>
          </div>
        </React.Fragment>
      )}
    </div>
  )
}
